import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const SplashScreen = ({ onComplete }) => {
  const navigate = useNavigate();
  const [showBuildings, setShowBuildings] = useState(false);

  useEffect(() => {
    // Mark splash as shown
    localStorage.setItem('splashShown', 'true');
    
    const timer1 = setTimeout(() => setShowBuildings(true), 1000);
    const timer2 = setTimeout(() => {
      onComplete();
      navigate('/home');
    }, 5000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [navigate, onComplete]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a7b 50%, #4A90A4 100%)'
      }}
    >
      {/* Transparent Buildings Background */}
      {showBuildings && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 0.1, y: 0 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0 flex items-end justify-center"
        >
          <svg viewBox="0 0 800 400" className="w-full h-3/4" xmlns="http://www.w3.org/2000/svg">
            {/* Building 1 */}
            <rect x="50" y="150" width="80" height="250" fill="white" opacity="0.15" />
            <rect x="58" y="170" width="15" height="20" fill="#4A90A4" opacity="0.3" />
            <rect x="85" y="170" width="15" height="20" fill="#4A90A4" opacity="0.3" />
            <rect x="112" y="170" width="15" height="20" fill="#4A90A4" opacity="0.3" />
            
            {/* Building 2 */}
            <rect x="150" y="100" width="100" height="300" fill="white" opacity="0.15" />
            <rect x="165" y="120" width="20" height="25" fill="#4A90A4" opacity="0.3" />
            <rect x="195" y="120" width="20" height="25" fill="#4A90A4" opacity="0.3" />
            <rect x="225" y="120" width="20" height="25" fill="#4A90A4" opacity="0.3" />
            
            {/* Building 3 */}
            <rect x="270" y="180" width="90" height="220" fill="white" opacity="0.15" />
            <rect x="285" y="200" width="18" height="22" fill="#4A90A4" opacity="0.3" />
            <rect x="315" y="200" width="18" height="22" fill="#4A90A4" opacity="0.3" />
            <rect x="340" y="200" width="18" height="22" fill="#4A90A4" opacity="0.3" />
            
            {/* Building 4 */}
            <rect x="650" y="120" width="100" height="280" fill="white" opacity="0.15" />
            <rect x="665" y="140" width="20" height="25" fill="#4A90A4" opacity="0.3" />
            <rect x="695" y="140" width="20" height="25" fill="#4A90A4" opacity="0.3" />
            <rect x="725" y="140" width="20" height="25" fill="#4A90A4" opacity="0.3" />
          </svg>
        </motion.div>
      )}

      {/* Logo Animation */}
      <motion.div
        initial={{ x: -500, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 2, ease: 'easeOut' }}
        className="relative z-10"
      >
        <img
          src={logo}
          alt="suvaidyam Hospital"
          className="w-96 h-auto"
        />
      </motion.div>

      {/* Tagline */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.5, duration: 1 }}
        className="absolute bottom-32 text-center"
      >
        <h2 className="text-white text-4xl font-light tracking-wide">
          Where Excellence Meets Compassion
        </h2>
      </motion.div>
    </motion.div>
  );
};

export default SplashScreen;